// src/api.js
// Central place for all API calls.
// In production the React app is served by the reverse proxy on the same domain,
// so we use a relative BASE_URL ('') and the proxy forwards /api/* → port 7000.
// In local dev we hit the backend directly on port 7000.
const BASE_URL = process.env.NODE_ENV === 'production'
  ? ''
  : (process.env.REACT_APP_API_URL || 'http://localhost:7000');

async function request(path, options = {}) {
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Something went wrong');
  return data;
}

// ─── COMPANIES ────────────────────────────────────────────────────────────────
export const companiesApi = {
  getAll: () => request('/api/companies'),
  add: (name) => request('/api/companies', {
    method: 'POST',
    body: JSON.stringify({ name }),
  }),
  remove: (id) => request(`/api/companies/${id}`, { method: 'DELETE' }),
};

// ─── RECIPIENTS ───────────────────────────────────────────────────────────────
export const recipientsApi = {
  getAll: () => request('/api/recipients'),
  add: (email) => request('/api/recipients', {
    method: 'POST',
    body: JSON.stringify({ email }),
  }),
  remove: (id) => request(`/api/recipients/${id}`, { method: 'DELETE' }),
};

// ─── REPORTS ──────────────────────────────────────────────────────────────────
export const reportsApi = {
  getAll: () => request('/api/reports'),
};
